<div class="jobber-timeline-item" [ngClass]="{'mt-0': index !=0}">
  <div class="jobber-timeline-cricle z-index-0">
    <i class="far fa-circle"></i>
  </div>
  <div class="jobber-timeline-info">
    <div class="dashboard-timeline-info">
      <div class="dashboard-timeline-edit" *ngIf="readonly == false">
        <ul class="list-unstyled d-flex">
          <li><a class="text-right" data-toggle="collapse" [routerLink]="" (click)="editEducation()" role="button"
              aria-expanded="false" aria-controls="dateposted"> <i class="fas fa-pencil-alt text-info mr-2"></i> </a>
          </li>
          <li><a [routerLink]="" (click)="deleteEducation()"><i class="far fa-trash-alt text-danger"></i></a></li>
        </ul>
      </div>
      <span class="jobber-timeline-time">{{education.year}}</span>
      <h6 class="mb-2">{{education.title}}</h6>
      <span>- {{education.institute}}</span>
      <p class="mt-2">{{education.description}}</p>
    </div>
    <div *ngIf="showEditForm">
      <app-education-form [education]="education" [index]="index" (saved)="educationSaved()"></app-education-form>
    </div>
  </div>
</div>